var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImportSide = function SvgImportSide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "import_side_svg2__a",
    x1: 0.7,
    x2: 206.33,
    y1: 174.47,
    y2: 20.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M25 139.99c2.76 0 5 2.24 5 5V175c0 8.28 6.72 15 15 15h109.99c8.28 0 15-6.72 15-15V50.01h-35c-2.76 0-5-2.24-5-5v-35H45c-8.28 0-15 6.72-15 15V45c0 2.76-2.24 5-5 5s-5-2.24-5-5V25.01c0-13.81 11.19-25 25-25h89.72c1.33-.08 2.71.36 3.82 1.46l40 40c1.11 1.11 1.55 2.49 1.46 3.82V175c0 13.81-11.19 25-25 25H45c-13.81 0-25-11.19-25-25v-30.01c0-2.76 2.24-5 5-5M139.99 17.08v22.93h22.93zM102.92 90 81.46 68.54a5.003 5.003 0 0 1 0-7.07 5.003 5.003 0 0 1 7.07 0l30 30a5.003 5.003 0 0 1 0 7.07l-30 30a5.003 5.003 0 0 1-7.07 0 5.003 5.003 0 0 1 0-7.07l21.46-21.46H25c-2.76 0-5-2.24-5-5s2.24-5 5-5h77.93Z",
    style: {
      fill: "url(#import_side_svg2__a)"
    }
  }));
};
export default SvgImportSide;